import axios, { AxiosResponse } from 'axios'
import { Enum, ID } from '../../../../../../_metronic/helpers'
import {
  ContatoList,
  EmpresaDtoCreate,
  EmpresaDtoUpdate,
  EmpresasQueryResponse,
  EmpresaView,
  EnderecoDtoCreate,
  EnderecoDtoUpdate,
  EnderecoList,
  EnderecoView,
  TipoEnderecoList,
} from './_models'
import { ArquivoDto } from '../../../atendimento/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const EMPRESA_URL = `${API_URL}/empresas`
const GET_EMPRESAS_URL = `${API_URL}/empresas`

const GET_ASO_AUTENTICADO_URL = `${API_URL}/relatorio`

export const getEmpresas = (query: string): Promise<EmpresasQueryResponse> => {
  return axios
    .get(`${GET_EMPRESAS_URL}?${query}`)
    .then((d: AxiosResponse<EmpresasQueryResponse>) => d.data)
}

/**
 * Busca todas as empresas com perfil responsável
 * @param query string
 * @returns EmpresasQueryResponse
 */
export const getEmpresasAdmin = (query: string): Promise<EmpresasQueryResponse> => {
  return axios
    .get(`${GET_EMPRESAS_URL}/admin?${query}`)
    .then((d: AxiosResponse<EmpresasQueryResponse>) => d.data)
}

export const getEmpresaById = (id: ID): Promise<EmpresaView> => {
  return axios
    .get(`${EMPRESA_URL}/${id}`)
    .then((response: AxiosResponse<EmpresaView>) => response.data)
}

export const getEnderecoByIdEmpresa = (id: ID): Promise<EnderecoList[]> => {
  return axios
    .get(`${EMPRESA_URL}/endereco/${id}`)
    .then((response: AxiosResponse<EnderecoList[]>) => response.data)
}
export const getTiposEndereco = (): Promise<TipoEnderecoList[]> => {
  return axios
    .get(`${API_URL}/endereco/tipos`)
    .then((response: AxiosResponse<TipoEnderecoList[]>) => response.data)
}

export const createEmpresa = (empresa: EmpresaDtoCreate): Promise<EmpresaView> => {
  return axios
    .post(EMPRESA_URL, empresa)
    .then((response: AxiosResponse<EmpresaView>) => response.data)
}

export const getAsoAutenticado = (hashAuth: string) => {
  return axios
    .get(`${GET_ASO_AUTENTICADO_URL}/${hashAuth}`)
    .then((response: AxiosResponse<ArquivoDto>) => response.data)
}

/* export const vincularRiscosClienteAtendimento = (
  idAtendimento: ID,
  riscos: Array<RiscoCliente>
): Promise<void> => {
  const requests = riscos.map((risco) =>
    adicionaFatorRisco(idAtendimento, String(risco.fatorRisco), '0')
  )
  return axios.all(requests).then(() => {})
} */

export const createEnderecoEmpresa = (
  idEmpresa: ID,
  endereco: EnderecoDtoCreate
): Promise<EnderecoView> => {
  return axios.post(`${EMPRESA_URL}/endereco/${idEmpresa}`, endereco)
}

export const updateEnderecoEmpresa = (
  idEmpresa: ID,
  endereco: EnderecoDtoUpdate
): Promise<EnderecoView> => {
  return axios.put(`${EMPRESA_URL}/endereco/${idEmpresa}`, endereco)
}

export const updateEmpresa = (empresa: EmpresaDtoUpdate): Promise<EmpresaView> => {
  return axios
    .put(`${EMPRESA_URL}/${empresa.id}`, empresa)
    .then((response: AxiosResponse<EmpresaView>) => response.data)
}

export const deleteEmpresa = (empresaId: ID): Promise<void> => {
  return axios.delete(`${EMPRESA_URL}/${empresaId}`)
}

/**
 * Toggle status ativo/inativo empresa
 * @param empresaId Identificador da empresa
 * @param ativo status - boolean
 * @returns EmpresaDtoUpdate
 */
export const toggleStatusEmpresa = (
  empresaId: number,
  data: EmpresaDtoUpdate
): Promise<EmpresaDtoUpdate> => {
  return axios.put(`${EMPRESA_URL}/${empresaId}`, data)
}

export const deleteSelectedEmpresa = (empresaIds: Array<ID>): Promise<void> => {
  const requests = empresaIds.map((id) => axios.delete(`${EMPRESA_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export const getLogo = (empresaId: ID): Promise<string> => {
  return axios
    .get(`${EMPRESA_URL}/logo/${empresaId}`)
    .then((resp: AxiosResponse<{ data: string }>) => resp.data.data)
}

/**
 * Busca contatos da empresa
 * @param empresaId Identificador da Empresa
 * @returns ContatoList[]
 */
export const getContatoEmpresa = (empresaId: number): Promise<ContatoList[]> => {
  return axios
    .get(`${EMPRESA_URL}/contato/${empresaId}`)
    .then((resp: AxiosResponse<ContatoList[]>) => resp.data)
}

/**
 * Busca contato de agendamentos da empresa
 * @param empresaId Identificador da Empresa
 * @returns ContatoList
 */
export const getContatoOfAgendamentoByEmpresa = (empresaId: number): Promise<ContatoList> => {
  return axios
    .get(`${EMPRESA_URL}/contato/agendamento/${empresaId}`)
    .then((resp: AxiosResponse<ContatoList>) => resp.data)
}

/**
 * Busca modalidades de atendimento da empresa
 * @param empresaId Identificador da Empresa
 * @returns Enum[]
 */
export const getModalidadesByEmpresa = (empresaId: number): Promise<Enum[]> => {
  return axios
    .get(`${EMPRESA_URL}/modalidade/${empresaId}`)
    .then((resp: AxiosResponse<Enum[]>) => resp.data)
}

/**
 * Busca endereços de atendimento da empresa
 * @param empresaId Identificador da Empresa
 * @returns EnderecoList[]
 */
export const getEmpresaEnderecoAtendimento = (empresaId: number): Promise<EnderecoList[]> => {
  return axios
    .get(`${EMPRESA_URL}/endereco/atendimento/${empresaId}`)
    .then((resp: AxiosResponse<EnderecoList[]>) => resp.data)
}

/**
 *
 * @param empresaId Identificador da empresa mae
 * @param empresa EmpresaDtoCreate
 * @returns EmpresaView
 */
export const createSubEmpresa = (
  empresaId: number,
  empresa: EmpresaDtoCreate
): Promise<EmpresaView> => {
  return axios
    .post(`${EMPRESA_URL}/${empresaId}`, empresa)
    .then((response: AxiosResponse<EmpresaView>) => response.data)
}

export {
  getEsusConfigEmpresa,
  updateEsusConfigEmpresa,
} from '../../../unidades/unidades-list/core/_requests'
